import React, { Component } from 'react';
import CollectionBrowser from "./../../components/collectionBrowser";
import LookBookQuoteContainer from "./../../components/lookBookQuoteContainer";
import CollectionHero from "./../../components/collectionHero";
import LookBookCenteredImage from "./../../components/lookBookCenteredImage";
import LookBookFullWidthImage from "./../../components/lookBookFullWidthImage";
import LookBookOnePhotoAndColor from "./../../components/lookBookOnePhotoAndColor";
import LookBookSideBySideImages from "./../../components/lookBookSideBySideImages";
import StoryFooter from "./../../components/storyFooter";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import BackButton from './../../alpineComponents/backButton';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";
import FlodeskForm from './../../components/flodeskForm';

//sevenDayChallenge

export default class SevenDayChallenge extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>{'Stay Connected with Kat Medina'}</title>
          <meta name="description" content="Sign up for more joy." />
        </Helmet>
        <BannerFadeIn>
          <div className="background-image-fill" style={{backgroundImage:`url(/images/intro-malacatos.jpg)`}}>
            <div className="brain-fucks-hero extra-large-padding centered-text" style={{backgroundColor:'rgba(0,0,0,.5)'}}>
              <h2 className="white full-width centered-text">{'Experience More Joy'}</h2>
              <p className="white">{'Don\'t just wait around for the world to bring you joy. Learn how to create it instead.'}</p>
            </div>
          </div>
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="small-max-width-container lip">
            <div className="primary-background centered-text mailchimp-form-container">
              <div className="small-max-width-container">
                <FlodeskForm />
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/subscribe/index.js